import { Component } from '@angular/core';
import { JobsJobPostingEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Job Postings') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-jobsjobposting-form',
    templateUrl: './jobsjobposting.form.component.html'
})
export class JobsJobPostingFormComponent extends BaseFormComponent {
    public record!: JobsJobPostingEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'jobPostingSources', sectionName: 'Job Posting Sources', isExpanded: false }
        ]);
    }
}

